import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  className: "playGround"
};
const _hoisted_2 = {
  class: "screenWrap"
};
const _hoisted_3 = {
  class: "screen"
};
const _hoisted_4 = {
  class: "setting"
};
const _hoisted_5 = {
  class: "operation"
};
const _hoisted_6 = {
  class: "opRightWrap"
};
const _hoisted_7 = {
  class: "opRight"
};
const _hoisted_8 = {
  class: "r1"
};
const _hoisted_9 = {
  class: "buttonUpLeft"
};
const _hoisted_10 = {
  class: "buttonUp"
};
const _hoisted_11 = {
  class: "buttonUpRight"
};
const _hoisted_12 = {
  class: "r2"
};
const _hoisted_13 = {
  class: "buttonLeft"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "buttonCenter"
}, null, -1);
const _hoisted_15 = {
  class: "buttonRight"
};
const _hoisted_16 = {
  class: "r3"
};
const _hoisted_17 = {
  class: "buttonDownLeft"
};
const _hoisted_18 = {
  class: "buttonDown"
};
const _hoisted_19 = {
  class: "buttonDownRight"
};
const _hoisted_20 = {
  class: "opLeftWrap"
};
const _hoisted_21 = {
  class: "opLeft"
};
const _hoisted_22 = {
  class: "l1"
};
const _hoisted_23 = {
  class: "buttonAB"
};
const _hoisted_24 = {
  class: "l2"
};
const _hoisted_25 = {
  class: "buttonA"
};
const _hoisted_26 = {
  class: "buttonB"
};
import { NesVue, vGamepad } from 'nes-vue';
import { showNotify } from 'vant';
import 'vant/es/notify/style';
import { useRoute } from 'vue-router';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import config from '../config/index';
export default {
  __name: 'PlayGround',
  setup(__props) {
    const query = useRoute().query;
    const romCode = ref(query.code);
    const nesRef = ref(null);
    const show = ref(false);
    const gain = ref('50');
    const showAction = () => {
      nesRef.value.pause();
      show.value = true;
    };
    // 存档
    const save = () => {
      nesRef.value.save(romCode.value);
      showNotify({
        type: 'success',
        message: '存档成功'
      });
      nesRef.value.play();
    };
    // 读档
    const load = () => {
      const request = window.indexedDB.open('nes-vue', 1); // 打开数据库
      // 打开成功
      request.onsuccess = function (event) {
        const db = event.target.result;
        const objectStoreName = 'save_data';
        // 通过事务从指定的对象仓库中获取所有记录
        const transaction = db.transaction([objectStoreName], 'readonly');
        const store = transaction.objectStore(objectStoreName);
        const getAllRequest = store.getAll();
        getAllRequest.onsuccess = function (event) {
          const data = event.target.result; // 获取返回结果
          const item = data.find(i => i.id === romCode.value);
          if (item) {
            // 有存档
            nesRef.value.load(romCode.value);
            showNotify({
              type: 'success',
              message: '读档成功'
            });
          } else {
            // 无存档
            showNotify({
              type: 'success',
              message: '暂无存档'
            });
          }
          nesRef.value.play();
        };
      };
    };
    // 重启游戏
    const reset = () => {
      showNotify({
        type: 'success',
        message: '游戏已重启'
      });
      nesRef.value.reset();
    };
    // 静音开关
    const setGain = () => {
      if (gain.value === '0') {
        gain.value = '50';
        showNotify({
          type: 'success',
          message: '静音-关'
        });
      } else {
        gain.value = '0';
        showNotify({
          type: 'success',
          message: '静音-开'
        });
      }
      nesRef.value.play();
    };
    const actions = [{
      name: '存档',
      callback: save
    }, {
      name: '读档',
      callback: load
    }, {
      name: '重启游戏',
      callback: reset
    }, {
      name: '静音(开/关)',
      callback: setGain
    }];
    const onSelect = () => {
      show.value = false;
    };
    const onClose = () => {
      nesRef.value.play();
    };

    // 处理双击长按后出现放大镜的逻辑
    let lastTouch = 0;
    let doubleTapTimer = 0;
    const handleTouchStart = event => {
      // 如果是长按，阻止默认行为
      if (event.touches.length > 1 || doubleTapTimer && new Date() - lastTouch < 200) {
        event.preventDefault();
      }
    };
    const handleTouchEnd = () => {
      // 记录每次触摸结束的时间
      lastTouch = new Date();
      // 如果两次触摸结束的时间间隔小于200ms，认为是双击
      if (doubleTapTimer) {
        clearTimeout(doubleTapTimer);
        // 执行自定义的双击事件处理逻辑
      } else {
        // 设置双击计时器
        doubleTapTimer = setTimeout(function () {
          // 执行自定义的单击事件处理逻辑
          doubleTapTimer = 0;
        }, 200);
      }
    };
    onMounted(() => {
      // 添加事件监听器
      document.addEventListener('touchstart', handleTouchStart, {
        passive: false
      });
      document.addEventListener('touchend', handleTouchEnd, {
        passive: false
      });
    });
    onBeforeUnmount(() => {
      // 移除事件监听器
      document.removeEventListener('touchstart', handleTouchStart, {
        passive: false
      });
      document.removeEventListener('touchend', handleTouchEnd, {
        passive: false
      });
    });
    return (_ctx, _cache) => {
      const _component_van_action_sheet = _resolveComponent("van-action-sheet");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(NesVue), {
        label: "点击开始游戏",
        ref_key: "nesRef",
        ref: nesRef,
        gain: gain.value,
        width: "100%",
        class: "nesWrap",
        height: "100%",
        url: `${_unref(config).serverUrl}/romStatic/rom/${romCode.value}.nes`
      }, null, 8, ["gain", "url"])]), _createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createTextVNode("START")])), [[_unref(vGamepad), 'START', "touch"]]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createTextVNode("SELECT")])), [[_unref(vGamepad), 'SELECT', "touch"]]), _createElementVNode("div", {
        onClick: showAction
      }, "设置")])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [[_unref(vGamepad), ['UP', 'LEFT'], "touch"]]), _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [[_unref(vGamepad), 'UP', "touch"]]), _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [[_unref(vGamepad), ['UP', 'RIGHT'], "touch"]])]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [[_unref(vGamepad), 'LEFT', "touch"]]), _hoisted_14, _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_unref(vGamepad), 'RIGHT', "touch"]])]), _createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [[_unref(vGamepad), ['DOWN', 'LEFT'], "touch"]]), _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [[_unref(vGamepad), 'DOWN', "touch"]]), _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [[_unref(vGamepad), ['DOWN', 'RIGHT'], "touch"]])])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [_createTextVNode("A + B")])), [[_unref(vGamepad), ['A', 'B'], "touch"]])]), _createElementVNode("div", _hoisted_24, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [_createTextVNode("A")])), [[_unref(vGamepad), 'A', "touch"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [_createTextVNode("B")])), [[_unref(vGamepad), 'B', "touch"]])])])])]), _createVNode(_component_van_action_sheet, {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => show.value = $event),
        "cancel-text": "取消",
        actions: actions,
        onSelect: onSelect,
        onClose: onClose
      }, null, 8, ["show"])]);
    };
  }
};